import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { LoaderOverlayService } from 'src/app/core/services/loader-overlay.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { MustMatch } from 'src/app/shared/validators/must-match.validator';
//import * as moment from "moment";
import { Router } from '@angular/router';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { EncryptDecryptService } from 'src/app/core/services/encrypt-decrypt.service';
//import { NgOtpInputComponent } from 'ng-otp-input';
declare var dataLayer;
@Component({
  selector: 'app-get-help-dialog',
  templateUrl: './get-help-dialog.component.html',
  styleUrls: ['./get-help-dialog.component.scss']
})
export class GetHelpDialogComponent implements OnInit {
  public initiateChangePasswordFormGroup: FormGroup;
  public resetPasswordFormGroup: FormGroup;
  public isGetHelp: boolean = true;
  public isOtp: boolean = false;
  public isPasswordUpdate: boolean = false;
  public loader: boolean = false;
  public userId: any;
  public userEmailIdOrMobileNo: any;
  public userMobileNumber: number;
  public userOtp: number;
  public maximumDOB;
  public hasUpper: boolean;
  public hasNum: boolean;
  public hasSpecial: boolean;
  public errMsg = 'Please enter atleast ';
  public passwordHide = true;
  public timeLeft: number = 0;
  public interval;
  public countTime = 20;
  public invalidOtp = false;
  public isvalidOtp: boolean = false;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: true,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '48px',
      'height': '72px'
    }
  };
  public userType: string;
  public userIdGA: any;
  public tierType: any;
  // @ViewChild(NgOtpInputComponent, { static: false})
  // public ngOtpInput:NgOtpInputComponent;
  constructor(
    private dialogRef: MatDialogRef<GetHelpDialogComponent>,
    private formBuilder: FormBuilder,
    private auth: AuthenticationService,
    private loaderOverlayService: LoaderOverlayService,
    private commonFunction: CommonFunctions,
    private encryptDecryptService : EncryptDecryptService,
    private router: Router
  ) {
    this.maximumDOB = new Date();
    this.maximumDOB.setFullYear(this.maximumDOB.getFullYear() - 18);
    this.userType = this.commonFunction.getUserType();
    this.userIdGA = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
  }
  ngOnInit(): void {
    this.buildResetPasswordForm();
  }
  buildResetPasswordForm(): void {
    this.initiateChangePasswordFormGroup = this.formBuilder.group({
      userNameOrMobileNo: ['', Validators.required],
      dateOfBirth: ['', [Validators.required]]
    });
  }
  buildChangePasswordForm(): void {
    this.resetPasswordFormGroup = this.formBuilder.group({
      password: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
      confirmPassword: ['', Validators.required]
    }, {
      validator: MustMatch('password', 'confirmPassword')
    });
  }
  public initateResetPassword(formData): any {
    if (this.initiateChangePasswordFormGroup.valid == true) {
      let requestPayload = {
        "userName": this.encryptDecryptService.encryptData(formData.userNameOrMobileNo),
       // "dateOfBirth": formData.dateOfBirth != '' ? this.encryptDecryptService.encryptData(moment(formData.dateOfBirth).format('YYYY-MM-DD')) : ''
      }
      this.userEmailIdOrMobileNo = formData.userNameOrMobileNo;
      this.userMobileNumber = formData.mobileNumber;
      this.commonFunction.showLoader();
      this.auth.initateResetPassword(requestPayload).subscribe((result: any) => {
        this.userId = result.response.userId;
        this.commonFunction.hideLoader();
        this.commonFunction.displaySnackBarMessage(result.response.message, 'success');
        this.isGetHelp = false;
        this.isOtp = true;
        this.startTimer(this.countTime);
        this.initiateResetPasswordGA();
      }, (error) => {
        this.commonFunction.hideLoader();
        this.commonFunction.processErrorMessage(error, 'failure')
      })
    }
  }
  public onOtpChange(value) {
    this.userOtp = value;
    if (value.length == 6) {
      this.isvalidOtp = true;
      this.invalidOtp = false;
    } else {
      this.isvalidOtp = false;
      this.invalidOtp = false;
    }
  }
  public verifyUserOtp(): void {
    let requestPayload = {
      "id": this.userId,
      "otp": this.encryptDecryptService.encryptData(this.userOtp),
      "otpChannelType": 'BOTH'
    }
    this.commonFunction.showLoader();
    this.auth.verifyOtp(requestPayload).subscribe((result) => {
      this.commonFunction.hideLoader();
      this.isGetHelp = false;
      this.isOtp = false;
      this.isPasswordUpdate = true;
      this.buildChangePasswordForm();
      this.getHelpOtpGA();
    }, (error) => {
      this.setVal('');
      this.commonFunction.hideLoader();
      this.commonFunction.processErrorMessage(error, 'failure')
    })
  }
  public resetPassword(formData): void {
    let requestPayload = {
      "userId": this.userId,
      "password": this.encryptDecryptService.encryptData(formData.password)
    }
    this.commonFunction.showLoader();
    this.auth.changePassword(requestPayload).subscribe((result) => {
      this.commonFunction.hideLoader();
      this.dialogRef.close();
      this.router.navigate(['/login']);
      this.commonFunction.displaySnackBarMessage(result['response'].message, 'success');
    }, (error) => {
      this.commonFunction.hideLoader();
      this.commonFunction.processErrorMessage(error, 'failure')
    })
  }
  public resendOtp() {
    let requestPayload = {
      "userId": this.userId,
      "userName": this.encryptDecryptService.encryptData(this.userEmailIdOrMobileNo)
    }
    this.commonFunction.showLoader();
    this.auth.getHelpResendOtp(requestPayload).subscribe((result) => {
      this.setVal('');
      this.startTimer(this.countTime);
      this.commonFunction.hideLoader();
    }, (error) => {
      this.setVal('');
      this.commonFunction.hideLoader();
      this.commonFunction.processErrorMessage(error, 'failure')
    })
  }
  onCloseClick(): void {
    this.dialogRef.close();
  }
  public validatePassword() {
    let result = this.commonFunction.validatePasswordPattern(this.resetPasswordFormGroup.get('password').value);
    this.hasUpper = result.hasUpper,
      this.hasNum = result.hasNum,
      this.errMsg = result.errorMsg,
      this.hasSpecial = result.hasSpecial
  }
  convertTimerValue(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return (
      ('00' + minutes).slice(-2) +
      ':' +
      ('00' + Math.floor(value - minutes * 60)).slice(-2)
    );
  }
  startTimer(timerValue: any): void {
    clearInterval(this.interval);
    this.timeLeft = timerValue;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      }
    }, 1000);
  }
  setVal(val) {
   // this.ngOtpInput.setValue(val);
    this.invalidOtp = false;
  }
  initiateResetPasswordGA(){
    dataLayer.push({
      'event': 'get_help_flow_details_click',
        'userID':this.userIdGA ,
        'user_type':this.userType
    })  
  }
  getHelpOtpGA(){
    dataLayer.push({
      'event':'get_help_flow_otp_confirm_click',
        'userID':this.userIdGA ,
        'user_type':this.userType
    })  
  }
  resetPasswordGA(){
    dataLayer.push({
      'event':'get_help_flow_reset_password_click',
        'userID':this.userIdGA ,
        'user_type':this.userType
    })  
  }
  crossBtnGA(){
    dataLayer.push({
      'event':'cross_click',
      'userID':this.userId,
      'user_type':this.userType,
      'tier':this.tierType
    })
  }
}